export function chargeReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        // case "NEW_CHARGE":            
        case "UPDATE_CHARGE":
        case "UPDATE_FETCH_CHARGE":
            let list = Object.assign({}, state);
            // delete list[payload.salary_line_id]
            list[payload.salary_line_id] = payload
        
            return list
            
        case "GET_CHARGES":
            return payload
        case "DELETE_CHARGE":            
            let list2 = Object.assign({}, state);
            
            delete list2.ADMIN[payload]
            
            return list2
            
        default:
            return state;
    }
    
}